import {NgModule} from "@angular/core";
import {RouterModule, Routes} from "@angular/router";
import {OfferFlowWrapperComponent} from "./components/offer-flow-wrapper/offer-flow-wrapper.component";
import {PageNotFoundComponent} from "fello-common";
import {JourneySettingsResponseResolver} from "./resolvers/journey-settings-response-resolver.service";

const routes: Routes = [
  {
    path: ":journeyId",
    component: OfferFlowWrapperComponent,
    title: "Sell My Home",
    resolve: {
      settings: JourneySettingsResponseResolver
    }
  },
  {
    path: "**",
    component: PageNotFoundComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class OfferFlowRoutingModule {}
